import React, { useEffect, useState } from "react";
import "./invition.css";
import { backend_url } from "../constants/backend";

function Invition() {

  const [rows, setRows] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [msg, setMsg] = useState("");
  const [loadingInvite, setLoadingInvite] = useState(false);
  const [inviteLoaderText, setInviteLoaderText] = useState("");
  const [showPhotoModal, setShowPhotoModal] = useState(false);
const [activePhoto, setActivePhoto] = useState("");
const [searchValue, setSearchValue] = useState("");




const getImageSrc = (base64) => {
  if (!base64) return "";
  if (base64.startsWith("data:image")) return base64;
  return `data:image/jpeg;base64,${base64}`;
};





  // Auto hide messages
  useEffect(() => {
    if (msg) {
      const t = setTimeout(() => setMsg(""), 5000);
      return () => clearTimeout(t);
    }
  }, [msg]);


const handleDownloadPhoto = async (base64Image, filename = "profile_photo.png") => {
  if (!base64Image) return;

  const img = new Image();
  img.src = getImageSrc(base64Image);

  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(img, 0, 0);

    canvas.toBlob(
      (blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
      },
      "image/png", // 🔥 PNG = no quality loss
      1
    );
  };
};

const handleSearch = () => {
  const value = searchValue.trim();

  if (!value) {
    setMsg("Please enter email or mobile number");
    return;
  }

  const index = rows.findIndex((row) => {
    const emailMatch =
      row.col3 &&
      row.col3.trim().toLowerCase() === value.toLowerCase();

    const mobileMatch =
      row.col2 &&
      row.col2.replace(/\s+/g, "") === value.replace(/\s+/g, "");

    return emailMatch || mobileMatch;
  });

  if (index === -1) {
    setMsg("No record found for this email or mobile");
    return;
  }

  setCurrentIndex(index);
  setMsg(`Showing result for ${value}`);
};



  // ChatGPT typing loader
  const startInviteTypingLoader = () => {
    let dots = "";
    setInviteLoaderText("Sending Invitation");

    return setInterval(() => {
      dots = dots.length < 4 ? dots + "." : "";
      setInviteLoaderText(`Sending Invitation${dots}`);
    }, 300);
  };

  // 🔥 FETCH read-sheet/ endpoint
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const resp = await fetch(`${backend_url}/read-sheet/`, {
          method: "GET",
        });

        if (!resp.ok) {
          throw new Error("Failed to load sheet data.");
        }

        const text = await resp.text();

        const parsed = text
          .split("\n")
          .filter((line) => line.trim().length > 0)
        .map((line, rowIndex) => {
  const cols = line.split(" | ");

  // ✅ FORCE 12 columns (because SELECTED_COLS has 12 items)
  while (cols.length < 12) {
    cols.push("");
  }

  // 🔍 DEBUG LOGS (YOU ASKED FOR THIS)
  console.log("──────────── ROW", rowIndex + 1, "────────────");
  console.log("RAW LINE:", line);
  console.log("COLS LENGTH:", cols.length);
  console.log("ALL COLS:", cols);
  console.log("👉 POINTS (18th column):", cols[11]);
  console.log("────────────────────────────────");

 return {
  col1: cols[0] || "",
  col2: cols[1] || "",
  col3: cols[2] || "",
  col4: cols[3] || "",
  col5: cols[4] || "",
  col6: cols[5] || "",
  col7: cols[6] || "",
  col8: cols[7] || "",
  col9: cols[8] || "",
  col10: cols[9] || "",    // Award
  inviteStatus: cols[10] || "", // ✅ SENT / NOT SENT (Q column)
  points: cols[11] || "0",  // Points (R column)
};

});


        setRows(parsed);
        setCurrentIndex(0);
      } catch (err) {
        setError("Unable to load sheet data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const currentRow = rows[currentIndex] || null;

  const handlePrevious = () => {
    setCurrentIndex((i) => (i > 0 ? i - 1 : i));
  };

  const handleNext = () => {
    setCurrentIndex((i) => (i < rows.length - 1 ? i + 1 : i));
  };

  // 🔥 SEND INVITATION (send-invitation/)
  const handleSave = async () => {
    if (!currentRow.col3) {
      setMsg("Email not found for this row.");
      return;
    }

    setLoadingInvite(true);
    setMsg("");

    const loaderInterval = startInviteTypingLoader();

    try {
      const resp = await fetch(`${backend_url}/send-invitation/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: currentRow.col3 }),
      });

      clearInterval(loaderInterval);
      setInviteLoaderText("");

      if (!resp.ok) {
        let errData = {};
        try {
          errData = await resp.json();
        } catch {
          errData = {};
        }

        setMsg(errData.detail || "Error sending invitation. Please try again.");
        setLoadingInvite(false);
        return;
      }

      setMsg(`Invitation sent to ${currentRow.col3} ✔️`);

      // Mark as sent in UI
      setRows((prev) => {
        const updated = [...prev];
        updated[currentIndex] = { ...updated[currentIndex], inviteStatus: "Sent" };

        return updated;
      });
    } catch (err) {
      clearInterval(loaderInterval);
      setInviteLoaderText("");
      setMsg("Error sending invitation. Please try again.");
    }

    setLoadingInvite(false);
  };

const handleUpdatePoints = async () => {
  try {
    const resp = await fetch(`${backend_url}/update-points/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: currentRow.col3,
        points: currentRow.points,
      }),
    });

    if (!resp.ok) {
      setMsg("Failed to update points");
      return;
    }

    const data = await resp.json();
    setMsg(data.message || "Points updated");
  } catch (err) {
    setMsg("Error updating points");
  }
};


const isSent =
  (currentRow?.inviteStatus || "").trim().toLowerCase() === "sent";


return (
  <div className="invition-container react-background" style={{ padding: "20px" }}>
    
    {/* 🔝 HEADER */}
    <div className="invition-content-wrapper" style={{ marginTop: "50px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "15px",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <h2 style={{ margin: 0 }}>Invitation</h2>

        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
         <input
  type="text"
  placeholder="Search by email or mobile"
  value={searchValue}
  onChange={(e) => setSearchValue(e.target.value)}
  style={{
    padding: "8px 10px",
    borderRadius: "6px",
    border: "1px solid #00eaff",
    background: "#00eaff",
    color: "black",
    width: "260px",
  }}
/>

         <button
  onClick={handleSearch}
  style={{
    padding: "8px 18px",
    background: "#00eaff",
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    cursor: "pointer",
  }}
>
  Search
</button>

        </div>
      </div>
    </div>

    {loading && <div>Loading data...</div>}
    {error && <div style={{ color: "red" }}>{error}</div>}

    {!loading && !error && currentRow && (
      <>
        {/* 🧾 CARD */}
        <div className="invition-content-wrapper invitation-card">

          {/* 🔝 TOP ROW */}
          <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
            
            {/* LEFT – ALL TEXT DETAILS (NO GAP) */}
            <div style={{ flex: 1 }}>
              <div><b>Name:</b> {currentRow.col1}</div>
              <div><b>Mobile:</b> {currentRow.col2}</div>
              <div><b>Email:</b> {currentRow.col3}</div>
              <div><b>Company:</b> {currentRow.col4}</div>
              <div><b>Designation:</b> {currentRow.col5}</div>

              {/* 🔽 MOVED HERE — GAP FIXED */}
              <div><b>Ref_by:</b> {currentRow.col6}</div>
              <div><b>References:</b> {currentRow.col7}</div>
              <div><b>Gender:</b> {currentRow.col8}</div>
              <div><b>Award:</b> {currentRow.col10}</div>
            </div>

            {/* RIGHT – PHOTO */}
            <div style={{ width: "160px", textAlign: "center" }}>
              {currentRow.col9 && (
                <>
                  <img
                    src={getImageSrc(currentRow.col9)}
                    alt="Profile"
                    onClick={() => {
                      setActivePhoto(getImageSrc(currentRow.col9));
                      setShowPhotoModal(true);
                    }}
                    style={{
                      width: "140px",
                      height: "140px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      border: "2px solid #00eaff",
                      cursor: "pointer",
                    }}
                  />

                  <button
                    onClick={() =>
                      handleDownloadPhoto(
                        currentRow.col9,
                        `${currentRow.col1 || "profile"}_photo.jpg`
                      )
                    }
                    style={{
                      marginTop: "8px",
                      width: "140px",
                      padding: "6px",
                      fontSize: "13px",
                      background: "#00eaff",
                      color: "#000",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    ⬇ Download
                  </button>
                </>
              )}
            </div>
          </div>

          {/* POINTS + INVITATION STATUS */}
          <div
            style={{
              marginTop: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <b>Points:</b>
              <input
                type="number"
                value={currentRow.points ?? ""}
                onChange={(e) => {
                  const val = e.target.value;
                  setRows((prev) => {
                    const updated = [...prev];
                    updated[currentIndex] = {
                      ...updated[currentIndex],
                      points: val,
                    };
                    return updated;
                  });
                }}
                style={{
                  width: "120px",
                  padding: "5px",
                  borderRadius: "6px",
                  border: "1px solid #00eaff",
                  background: "transparent",
                  color: "white",
                }}
              />
              <button
                onClick={handleUpdatePoints}
                style={{
                  padding: "8px 18px",
                  background: "#00eaff",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Update Points
              </button>
            </div>

            <div
              style={{
                padding: "1px 10px",
                borderRadius: "999px",
                fontWeight: "bold",
                background: isSent ? "#00eaff" : "#ca8a04",
                color: "#000",
                minWidth: "160px",
                textAlign: "center",
              }}
            >
              {isSent ? "Invitation Sent" : "Invitation Not Sent"}
            </div>
          </div>
        </div>

        {/* 🔘 BUTTONS — KEPT AS REQUESTED */}
        <div className="invition-content-wrapper invition-btn-group">
          <button
            onClick={handlePrevious}
            disabled={currentIndex === 0}
            className="invition-btn prev-btn"
          >
            Previous
          </button>

          <button
            onClick={handleSave}
            className="invition-btn save-btn"
            disabled={loadingInvite || isSent}
          >
            {isSent ? "Sent" : "Send Invitation"}
          </button>

          <button
            onClick={handleNext}
            disabled={currentIndex === rows.length - 1}
            className="invition-btn next-btn"
          >
            Next
          </button>
        </div>

        {/* LOADER */}
        {loadingInvite && inviteLoaderText && (
          <div
            style={{
              marginTop: "10px",
              color: "#00eaff",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            {inviteLoaderText}
          </div>
        )}

        {/* MESSAGE */}
        {msg && (
          <div
            style={{
              marginTop: "15px",
              color: "#00ff99",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "15px",
            }}
          >
            {msg}
          </div>
        )}

        <div style={{ marginTop: 10, fontSize: 13, color: "#fff", textAlign: "center" }}>
          Row {currentIndex + 1} of {rows.length}
        </div>
      </>
    )}

    {/* PHOTO MODAL */}
    {showPhotoModal && (
      <div
        onClick={() => setShowPhotoModal(false)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.8)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "relative",
            maxWidth: "90%",
            maxHeight: "90%",
          }}
        >
          <div
            onClick={() => setShowPhotoModal(false)}
            style={{
              position: "absolute",
              top: "-12px",
              right: "-12px",
              background: "#ff004f",
              color: "#fff",
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ✕
          </div>

          <img
            src={activePhoto}
            alt="Full Profile"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              borderRadius: "10px",
              border: "2px solid #00eaff",
            }}
          />
        </div>
      </div>
    )}
  </div>
);



}

export default Invition;
